import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {ControlProcedureConditionForChartView, ControlProcedureInfo} from './controlprocedure.model';
import {environment} from '../../../../src/environments/environment';
import {ControlprocedureModel} from './controlprocedure.model';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ReactiveService} from '../reactive-service.abstract';


@Injectable()
export class ControlprocedureApiService extends ReactiveService  {

  protected baseUrlV2 = environment.backEndUrlPrefix + '/v2/controlprocedure';
  protected baseUrlDb = environment.backEndUrlPrefix + '/db/controlprocedure';
  private createCDPUrlV2 = environment.backEndUrlPrefix + '/v2/contrdeviceparam';
  private createCDPUrlDb = environment.backEndUrlPrefix + '/db/contrdeviceparam';

  constructor(protected http: HttpClient) {
    super();
  }

  getProceduresForParams(config: { ccp: number[], cdp: number[] }): Observable<ControlProcedureInfo[]> {
    return this.http.post<ControlProcedureInfo[]>(`${this.baseUrlDb}/forparams`, config);
  }

  getProcedureBordersById(id: number): Observable<ControlProcedureConditionForChartView[]> {
    return this.http.get<ControlProcedureConditionForChartView[]>(`${this.baseUrlDb}/${id}/borders`);
  }

  get(id): Observable<ControlprocedureModel> {
    return this.http.get<ControlprocedureModel>(this.baseUrlV2 + '/' + id);
  }

  getNew() {
    return {};
  }

  create(data: ControlprocedureModel, contrdeviceparamId?: number): Observable<ControlprocedureModel> {
    if (contrdeviceparamId) {
      if (data.conditions && data.conditions.length > 0) {
        return this.http.post(`${this.createCDPUrlV2}/${contrdeviceparamId}/proc`, data);
      } else {
        return this.http.post(`${this.createCDPUrlDb}/${contrdeviceparamId}/proc`, data);
      }
    }
    return this.http.post(`${this.baseUrlDb}`, data);
  }

  save(Id: number, data: ControlprocedureModel): Observable<ControlprocedureModel> {
    if (data.conditions && data.conditions.length >= 0) {
      return this.http.put(`${this.baseUrlDb}/${Id}`, data);
    } else {
      return this.http.put(`${this.baseUrlDb}/${Id}`, data);
    }
  }

  delete(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrlDb, {params: {id: ids.map(id => String(id))}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ControlprocedureModel> | Promise<ControlprocedureModel> | ControlprocedureModel {
    if (route.data.breadcrumb === 'Create') {
      return this.getNew();
    }
    return this.get(route.params.customcontrolprocedureId || route.params.controlprocedureId);
  }

}
